import React, { useState } from "react";
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Modal } from "antd";
import { Switch } from "antd";

import { API_CREATE_MAIN_LAUNDRY } from "api/main-laundry-management";
import { CONSTANTS } from "config/constant";
import { API_CREATE_ROLE } from "api/role-management";
import { API_UPDATE_ROLE } from "api/role-management";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";

const EditRole = () => {
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // State for modal visibility
  const [valuesData, setValuesData] = useState(); // State for modal visibility
  const { t } = useTranslation();
  const location = useLocation();
  const Navigate = useNavigate();

  const data = location.state && location.state.data;
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              role_name: data?.role_name,
              role_description: data?.role_description,
              role_status: data?.role_status, // Initialize with false for off state
            }}
            validationSchema={Yup.object({
              role_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              role_description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              role_status: Yup.string().required("Required"),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              setValuesData(values);
              setConfirmModalVisible(true);

              // console.log("values", values);
              // try {
              //   const userData = await API_UPDATE_ROLE(values, data?._id);
              //   Navigate("/admin/role/role-tables");

              //   toast.success(userData?.message);
              // } catch (error) {
              //   console.error("error", error);
              //   toast.error(error?.response?.data?.message);
              // } finally {
              //   setSubmitting(false);
              // }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <div>
                  <div
                    className="mb-9 flex cursor-pointer items-center gap-2"
                    onClick={() => {
                      Navigate(-1);
                    }}
                  >
                    <MdOutlineArrowBack
                      className="cursor-pointer"
                      style={{ fontSize: "17px" }}
                    />
                    <p>Back</p>
                  </div>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <div className="mb-3">
                        <label className="font-semibold">
                          {" "}
                          {t("Role Name")}
                          <span className="text-[red]">*</span>
                        </label>
                        <Field
                          // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                          className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                          type="text"
                          name="role_name"
                          placeholder={t("Role Name")}
                          maxLength={20}
                          onKeyPress={(event) => {
                            const charCode = event.charCode;
                            if (
                              !(charCode >= 65 && charCode <= 90) && // A-Z
                              !(charCode >= 97 && charCode <= 122) && // a-z
                              charCode !== 32 // space
                            ) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <ErrorMessage
                          name="role_name"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>

                    <Col span={8}>
                      <div className="mb-3">
                        <label className="font-semibold">
                          {" "}
                          {t("Role Description")}
                          <span className="text-[red]">*</span>
                        </label>
                        <Field
                          // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                          className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                          as="textarea"
                          name="role_description"
                          placeholder={t("Role Description")}
                        />
                        <ErrorMessage
                          name="role_description"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>

                    <Col span={8}>
                      <div className="mb-3">
                        <label className="font-semibold">
                          {t("Role Status")}
                          <span className="text-[red]">*</span>
                        </label>
                        <Switch
                          className="mt-2 flex   items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                          checked={values.role_status}
                          onChange={(value) =>
                            setFieldValue("role_status", value)
                          }
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {/* {isSubmitting ? "Updating..." : " Update Role"} */}
                    {isSubmitting ? t("Updating") + "..." : t("Update Role")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* Confirmation Modal */}
          <Modal
            // title="Save Changes"
            visible={confirmModalVisible}
            onCancel={() => setConfirmModalVisible(false)}
            centered
            onOk={async () => {
              setConfirmModalVisible(false);
              try {
                const userData = await API_UPDATE_ROLE(valuesData, data?._id);
                Navigate("/admin/role/role-tables");

                toast.success(userData?.message);
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                // setSubmitting(false);
              }
            }}
          >
            <div
              className="flex items-center"
              style={{ flexDirection: "column" }}
            >
              <div>
                <p className="mb-1 font-bold">Save Changes</p>
                <p className="mb-8 font-medium">
                  Do you want to Save Changes before leaving the Page?
                </p>
              </div>
              <div className="flex gap-4">
                <button
                  className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={() => setConfirmModalVisible(false)}
                  style={{ width: "6rem" }}
                >
                  Cancel
                </button>
                <button
                  className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={async () => {
                    setConfirmModalVisible(false);
                    try {
                      const userData = await API_UPDATE_ROLE(
                        valuesData,
                        data?._id
                      );
                      Navigate("/admin/role/role-tables");

                      toast.success(userData?.message);
                    } catch (error) {
                      console.error("error", error);
                      toast.error(error?.response?.data?.message);
                    } finally {
                      // setSubmitting(false);
                    }
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default EditRole;
